var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegenerate = function SvgRegenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 38"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.458,
    height: 36.458,
    x: 0.375,
    y: 0.792,
    fill: "#000",
    fillOpacity: 0.5,
    rx: 18.229
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.094,
    d: "m21.897 12.27.752.732c.336.327.504.49.445.63-.06.139-.297.139-.772.139h-5.82c-2.98 0-5.396 2.35-5.396 5.25 0 1.115.357 2.15.967 3M15.314 25.77l-.752-.731c-.336-.327-.504-.49-.445-.63.06-.139.297-.139.772-.139h5.82c2.98 0 5.397-2.35 5.397-5.25a5.13 5.13 0 0 0-.968-3"
  })));
};
export default SvgRegenerate;